<template>
	<div class="lmy-about">
		<img src="./../../assets/img/about/1.jpg" />
		<img src="./../../assets/img/about/2.jpg" />
		<img src="./../../assets/img/about/3.jpg" />
		<img src="./../../assets/img/about/4.jpg" />
		<img src="./../../assets/img/about/5.jpg" />
		<img src="./../../assets/img/about/6.jpg" />
		<img src="./../../assets/img/about/7.jpg" />
		<img src="./../../assets/img/about/8.jpg" />
		<img src="./../../assets/img/about/9.jpg" />
		<img src="./../../assets/img/about/10.jpg" />
	</div>
</template>
<script>
	export default{
		name:'about'
	}
</script>


// WEBPACK FOOTER //
// src/components/usr/about.vue